module.exports = __webpack_public_path__ + "static/media/LMC3.91446cec.png";